
import { defineComponent, computed } from "vue-demi";

export default defineComponent({
  name: "DocumentsTreeNode",
  props: {
    node: Object,
    selectedPath: String,
    expandedNodes: Object,
    level: {
      type: Number,
      default: 1,
    },
    parentExpanded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["select"],
  setup(props, { emit }) {
    const isSelected = computed(() => props.selectedPath === props.node.full_route);
    const expanded = computed(() => props.expandedNodes[props.node.full_route] || isSelected.value);
    const isUnfolded = computed(() => expanded.value);
    // const isUnfolded = computed(() => expanded.value || props.parentExpanded);
    const hasChildren = computed(
      () => Array.isArray(props.node.children) && props.node.children.length > 0
    );

    function selectAndExpand() {
      emit("select", props.node.full_route);
    }

    return {
      isSelected,
      expanded,
      isUnfolded,
      selectAndExpand,
      hasChildren,
    };
  },
});
